'use client'

// Narrow, per-concern selector hook for the header scroll controller (#118
// server-chrome, Step 3). Mirrors the Step-1 read-seam discipline
// (components/Footer/useNewsletterForm.js): it exposes ONLY the single action the
// NavScrollController island needs — saveNavbarElementProps — and nothing else
// from the store leaks through this seam.
//
// RISK REGISTER #2: the old class <Header> received `actions` as a PROP (drilled
// from Layout) and called this.props.actions.saveNavbarElementProps(...). The
// island now reads the action ITSELF so no actions are prop-drilled across the
// server-shell boundary (a function prop is not RSC-serialisable). The behaviour
// is identical: navbarElementProps is still written on every scroll tick, so the
// SecondaryNavbar (which reads navbarElementProps.offsetTop/offsetHeight) keeps
// pinning correctly. navbarElementProps moved off Overmind to the Zustand ui store
// (Phase C2 part 1); selecting the action (a stable ref) never re-renders on scroll.

import { useUiStore } from '../../store/uiStore'

export function useNavbarProps() {
  const saveNavbarElementProps = useUiStore((s) => s.saveNavbarElementProps)
  return { saveNavbarElementProps }
}
